import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import * as BoardAction from './BoardAction';
import simpleDotProp from '../simpleDotProp';
import {
  PostListStateToProps,
  PostListDispatchToProps,
} from './PostListDefaultProps';
import { showPlatform } from './PostShowPlatform';
import { generateQuery, getQueryObjFromRouter } from '../../utils/miscUtils';

const PostListInjector =
  (stateToProps = null, dispatchToProps = null) =>
  (WrapperComponent) => {
    const HOCComponent = class _HOCComponent extends Component {
      componentDidUpdate(prevProps, prevState) {
        if (this.props.initLoad === true) {
          if (
            JSON.stringify(prevProps.history.query) !==
            JSON.stringify(this.props.history.query)
          ) {
            const query = { ...this.props.history.query };
            this.props.getPostList(query);
          }
        }
      }

      componentDidMount() {
        if (this.props.initLoad === true) {
          const query = {
            ...this.props.history.query,
            ...getQueryObjFromRouter(this.props.history),
          };
          this.props.loadPostList(query);
        }
      }

      render() {
        return <WrapperComponent {...this.props} />;
      }
    };

    HOCComponent.propTypes = {
      boardName: PropTypes.string.isRequired,
      boardType: PropTypes.string.isRequired,
      pageSize: PropTypes.number.isRequired,
    };

    HOCComponent.defaultProps = {
      initLoad: true,
    };

    const mapDispatchToProps = (dispatch, ownProps) => {
      const { boardType, boardName, pageSize, listPageSub } = ownProps;
      const query = { ...ownProps.history.query };
      let props = {};
      if (dispatchToProps !== null) {
        props = dispatchToProps(dispatch, ownProps);
      }
      return {
        goSubPostList: (pageQuery) => {
          let newQuery = {};
          if (pageQuery) {
            newQuery = { ...pageQuery };
          }
          newQuery = showPlatform(ownProps, newQuery);
          ownProps.history.push(`${listPageSub}${generateQuery(newQuery)}`);
        },
        loadPostList: (pageQuery) => {
          const pageno = pageQuery.pageno ?? 1;
          const newQuery = showPlatform(ownProps, pageQuery);
          dispatch(
            BoardAction.loadPostList(
              boardType,
              boardName,
              pageno,
              pageSize,
              newQuery
            )
          );
        },
        getPostList: (pageQuery) => {
          const pageno = pageQuery.pageno ?? 1;
          const newQuery = showPlatform(ownProps, pageQuery);
          dispatch(
            BoardAction.getPostList(
              boardType,
              boardName,
              pageno,
              pageSize,
              newQuery
            )
          );
        },
        getPostListByPostId: (representativeChildList) => {
          dispatch(BoardAction.getPostListByPostId(representativeChildList));
        },
        recommendPost: (postId, isOn) => {
          dispatch(BoardAction.recommendPost(postId, isOn));
        },
        changePageSize: (pageSize, isOnlyDispatch) => {
          if (isOnlyDispatch) {
            dispatch(BoardAction.changePageSizeOnlyDispatch(pageSize));
          } else {
            const newQuery = showPlatform(ownProps, query);
            dispatch(
              BoardAction.changePageSize(
                boardType,
                boardName,
                pageSize,
                newQuery
              )
            );
          }
        },
        getPostLikeList: (actorId, postIdList) => {
          dispatch(
            BoardAction.getPostLikeList(
              boardType,
              boardName,
              actorId,
              postIdList
            )
          );
        },
        initPostList: (initPostCategory = false) => {
          if (initPostCategory === true) {
            dispatch(BoardAction.initPostCategory());
          }
          dispatch(BoardAction.initPostList());
        },
        getFiles: (postId) => {
          dispatch(BoardAction.getFileList(postId));
        },
        ...PostListDispatchToProps(dispatch, ownProps),
        ...props,
      };
    };

    const mapStateToProps = (state, ownProps) => {
      let props = {};
      if (stateToProps !== null) {
        props = stateToProps(state, ownProps);
      }
      return {
        boardInfo: simpleDotProp.deepCopy(state.BoardReducer.boardInfo),
        postList: simpleDotProp.deepCopy(state.BoardReducer.postList),
        postLikeList: simpleDotProp.deepCopy(state.BoardReducer.postLikeList),
        query: state.BoardReducer.query,
        pageSize: state.BoardReducer.pageSize
          ? state.BoardReducer.pageSize
          : ownProps.pageSize,
        representativeChild: simpleDotProp.deepCopy(
          state.BoardReducer.representativeChild
        ),
        ...PostListStateToProps(state, ownProps),
        ...props,
      };
    };

    return connect(mapStateToProps, mapDispatchToProps)(HOCComponent);
  };

export default PostListInjector;
